import fileSys from "../../fileoprators/fileSystem";
import { INVALID_1000, MAP_K_DATA } from "../../shared/consts";

const addonFA = window.__ct__.debug ? null : window.require(fileSys.getUtilPath("DEA520FA.node"));

// const DEFAULT_SHOWN = {
//   paramsSph: [
//     { label: 'Spherical Rmin', value: '--' },
//     { label: 'Spherical 3 mm', value: '--' },
//     { label: 'Spherical 6 mm', value: '--' },
//     { label: 'Spherical ecc 8 mm', value: '--' }
//   ],
//   paramsDecent: [
//     { label: 'Decentration 3 mm', value: '--' },
//     { label: 'Decentration 6 mm', value: '--' }
//   ],
//   paramsRegular: [
//     { label: 'Astigmatism 3 mm', value: '--' },
//     { label: 'Astigmatism 6 mm', value: '--' }
//   ],
//   paramsIrregular: [
//     { label: 'Irregularity 3 mm', value: '--' },
//     { label: 'Irregularity 6 mm', value: '--' }
//   ]
// }

const GetShown = function (objCaled) {
  let shown = {
    paramsSph: [
      { label: "Spherical Rmin", value: "--" },
      { label: "Spherical 3 mm", value: "--" },
      { label: "Spherical 6 mm", value: "--" },
      { label: "Spherical ecc 8 mm", value: "--" }
    ],
    paramsDecent: [
      { label: "Decentration 3 mm", value: "--" },
      { label: "Decentration 6 mm", value: "--" }
    ],
    paramsRegular: [
      { label: "Astigmatism 3 mm", value: "--" },
      { label: "Astigmatism 6 mm", value: "--" }
    ],
    paramsIrregular: [
      { label: "Irregularity 3 mm", value: "--" },
      { label: "Irregularity 6 mm", value: "--" }
    ]
  };

  if (objCaled) {
    let strarr = [];
    for (let i = 0; i < objCaled.length; i++) {
      let fixedNum = 2;
      let needLess180 = false;
      if (i === 6 || i === 7 || i === 10 || i === 11) {
        fixedNum = 0;
        if (i === 10 || i === 11) {
          needLess180 = true;
        }
      }
      strarr.push(GetStrVal(objCaled[i], fixedNum, needLess180));
    }

    shown.paramsSph[0].value = strarr[0];
    shown.paramsSph[1].value = strarr[1];
    shown.paramsSph[2].value = strarr[2];
    shown.paramsSph[3].value = strarr[3];

    shown.paramsDecent[0].value = `${strarr[4]} @ ${strarr[6]}°`;
    shown.paramsDecent[1].value = `${strarr[5]} @ ${strarr[7]}°`;

    shown.paramsRegular[0].value = `${strarr[8]} @ ${strarr[10]}°`;
    shown.paramsRegular[1].value = `${strarr[9]} @ ${strarr[11]}°`;

    shown.paramsIrregular[0].value = strarr[12];
    shown.paramsIrregular[1].value = strarr[13];
  }

  return shown;
};
const GetStrVal = function (value, fixedNum = 2, needLess180 = false) {
  if (value === INVALID_1000 || isNaN(value)) {
    return "--";
  } else {
    if (needLess180 && value > 180) {
      value = value - 180;
    }
    return value._toFixed(fixedNum);
  }
};
export default {
  Calculate(sagfcartFile) {
    if (addonFA) {
      var kLen = 601 * 601;
      var pSph = new Float64Array(kLen);
      var pDecent = new Float64Array(kLen);
      var pRegular = new Float64Array(kLen);
      var pIrregular = new Float64Array(kLen);
      var pValues = new Float64Array(14);
      let obj = addonFA.FourierAnalysis(
        sagfcartFile,
        pSph.buffer,
        pDecent.buffer,
        pRegular.buffer,
        pIrregular.buffer,
        pValues.buffer
      );
      for (let i = 0; i < kLen; i++) {
        // if (pSph[i] !== 0 && pSph[i] !== INVALID_1000) {
        //   pSph[i] = MAP_DATA / pSph[i]
        // } else {
        //   pSph[i] = INVALID_1000
        // }
        if (pDecent[i] !== 0 && pDecent[i] !== INVALID_1000) {
          pDecent[i] = MAP_K_DATA / pDecent[i];
        } else {
          pDecent[i] = INVALID_1000;
        }
        if (pRegular[i] !== 0 && pRegular[i] !== INVALID_1000) {
          pRegular[i] = MAP_K_DATA / pRegular[i];
        } else {
          pRegular[i] = INVALID_1000;
        }
        if (pIrregular[i] !== 0 && pIrregular[i] !== INVALID_1000) {
          pIrregular[i] = MAP_K_DATA / pIrregular[i];
        } else {
          pIrregular[i] = INVALID_1000;
        }
      }
      return {
        result: obj && obj.result === 0,
        sph: pSph,
        decent: pDecent,
        regular: pRegular,
        irregular: pIrregular,
        value: GetShown(pValues)
      };
    } else {
      return {
        result: false,
        sph: null,
        decent: null,
        regular: null,
        rregular: null,
        value: GetShown(null)
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/topography/js/FourierCalculate.js